import {
  listen,
  uiStateMessage,
  isUiStateRequestMessage,
  sendLocal,
  type UI_STATE_PAYLOAD,
} from "@sinch/bus";
import { useEffect } from "react";
import { useSidebarState } from "../../../hooks/state";

export const useUiStateHandler = () => {
  const state = useSidebarState();
  useEffect(() => {
    const uiConfig: UI_STATE_PAYLOAD = {
      menu: {
        mobile: {
          isOpen: false,
        },
        desktop: {
          isDisabled: false,
          isCollapsed: state.isCollapsed,
          isHovering: false,
          isCollapseDisabled: false,
        },
      },
    };

    const unsub = listen(() => {
      sendLocal(uiStateMessage(uiConfig));
    }, isUiStateRequestMessage);

    return unsub;
  }, [state]);
};
